var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23.89,
    viewBox: "0 0 23 23.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    transform: "translate(-98.001 -27.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M248.2,385.17h1.539a.426.426,0,0,1,.4.4v.606a.4.4,0,0,1-.4.4H248.2a.426.426,0,0,1-.4-.4v-.606A.4.4,0,0,1,248.2,385.17Z",
    transform: "translate(-142.889 -340.103)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M248.2,321.61h1.539a.426.426,0,0,1,.4.4v.606a.4.4,0,0,1-.4.4H248.2a.426.426,0,0,1-.4-.4v-.606A.4.4,0,0,1,248.2,321.61Z",
    transform: "translate(-142.889 -279.58)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M157.867,385.17h1.539a.426.426,0,0,1,.4.4v.606a.4.4,0,0,1-.4.4h-1.539a.426.426,0,0,1-.4-.4v-.606A.4.4,0,0,1,157.867,385.17Z",
    transform: "translate(-56.993 -340.103)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M157.867,321.61h1.539a.426.426,0,0,1,.4.4v.606a.4.4,0,0,1-.4.4h-1.539a.426.426,0,0,1-.4-.4v-.606A.4.4,0,0,1,157.867,321.61Z",
    transform: "translate(-56.993 -279.58)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M248.2,258.05h1.539a.426.426,0,0,1,.4.4v.606a.4.4,0,0,1-.4.4H248.2a.426.426,0,0,1-.4-.4v-.606A.4.4,0,0,1,248.2,258.05Z",
    transform: "translate(-142.889 -219.058)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M120.969,89a6.107,6.107,0,0,0-2.622-4.46V75.65a2,2,0,0,0-.543-1.376,1.811,1.811,0,0,0-1.309-.571h-1.178v2.105a2.577,2.577,0,0,1-1.214,2.209,2.326,2.326,0,0,1-2.428,0,2.577,2.577,0,0,1-1.214-2.209V73.7h-4.574v2.105a2.577,2.577,0,0,1-1.214,2.209,2.326,2.326,0,0,1-2.428,0,2.577,2.577,0,0,1-1.214-2.209V73.7H99.854a1.811,1.811,0,0,0-1.309.571A2,2,0,0,0,98,75.65V90.956a2,2,0,0,0,.543,1.376,1.811,1.811,0,0,0,1.309.571H110.4a5.728,5.728,0,0,0,4.222,2.751,5.592,5.592,0,0,0,4.687-1.729A6.232,6.232,0,0,0,120.969,89Zm-5.724,5.468a4.458,4.458,0,0,1-2.825-1.008,4.857,4.857,0,0,1-1.642-2.617.593.593,0,0,0-.639-.462.573.573,0,0,0-.4.26.63.63,0,0,0-.081.486c.048.191.1.376.166.559H99.859a.686.686,0,0,1-.5-.215.758.758,0,0,1-.207-.526V81.109H117.2v2.838a5.452,5.452,0,0,0-1.211-.312,5.578,5.578,0,0,0-4.789,1.7V83.8a.576.576,0,1,0-1.15,0v3.988h3.8a.6.6,0,0,0,0-1.208h-2.169a4.493,4.493,0,0,1,4.114-1.737,4.621,4.621,0,0,1,3.6,2.72,5.048,5.048,0,0,1-.259,4.651,4.554,4.554,0,0,1-3.876,2.261Z",
    transform: "translate(0 -43.802)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M465.72,360.358l1.166-1.166a.466.466,0,1,0-.658-.66l-1.5,1.5a.466.466,0,0,0,0,.66l2.321,2.3a.467.467,0,1,0,.66-.66Z",
    transform: "translate(-349.313 -313.731)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M397.426,32.9a1.166,1.166,0,0,0,1.166-1.166V29.164a1.166,1.166,0,1,0-2.332,0V31.73a1.166,1.166,0,0,0,1.166,1.166Z",
    transform: "translate(-284.5)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M190.786,32.9a1.166,1.166,0,0,0,1.166-1.166V29.164a1.166,1.166,0,1,0-2.332,0V31.73a1.166,1.166,0,0,0,1.166,1.166Z",
    transform: "translate(-87.393)",
    fill: "#a0a0a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.6da4eb4db6a7b5bfa9b6addbb5739458.svg";
export { ForwardRef as ReactComponent };